import { ref, uploadBytes, getDownloadURL, deleteObject, getBlob } from 'firebase/storage';
import { storage } from './index';

export const uploadPhoto = async (file, path) => {
  try {
    const storageRef = ref(storage, path);
    const snapshot = await uploadBytes(storageRef, file);
    const url = await getDownloadURL(snapshot.ref);
    return { url, fullPath: snapshot.ref.fullPath, error: null };
  } catch (e) {
    return { url: null, fullPath: null, error: e.message };
  }
};

export const deletePhoto = async (fullPath) => {
  try {
    const storageRef = ref(storage, fullPath);
    await deleteObject(storageRef);
    return { error: null };
  } catch (e) {
    return { error: e.message };
  }
};

// Extract Firebase Storage path from download URL
const extractStoragePath = (url) => {
  try {
    const urlObj = new URL(url);
    // Firebase URL format: /v0/b/{bucket}/o/{encodedPath}
    const match = urlObj.pathname.match(/\/o\/(.+)$/);
    if (match) {
      return decodeURIComponent(match[1]);
    }
  } catch (e) {
    console.warn('[extractStoragePath] Failed to parse URL:', url);
  }
  return null;
};

// Download a file from Firebase Storage using the SDK (bypasses CORS)
export const downloadFile = async (url, filename) => {
  try {
    const path = extractStoragePath(url);
    if (!path) {
      // Fallback: try direct fetch
      const response = await fetch(url, { mode: 'cors', credentials: 'omit' });
      if (!response.ok) throw new Error('Fetch failed');
      const blob = await response.blob();
      return { blob, error: null };
    }

    const storageRef = ref(storage, path);
    const blob = await getBlob(storageRef);
    return { blob, error: null };
  } catch (e) {
    return { blob: null, error: e.message };
  }
};
